export default __webpack_public_path__ + "static/media/matrimony.03d6f330.png";